import { render } from "./StafetDonationTaendLysStepOne.vue?vue&type=template&id=42684492"
import script from "./StafetDonationTaendLysStepOne.vue?vue&type=script&lang=js"
export * from "./StafetDonationTaendLysStepOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__